import React from 'react';
import { Form, Input, Select, Button, Row, Col, Space } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import MomentDatePicker from '../MomentDatePicker';

const { Option } = Select;
const { TextArea } = Input;

const MedicalConditionsSection = () => {
  const { t } = useTranslation();

  return (
    <Form.List name="medicalConditions">
      {(fields, { add, remove }) => (
        <>
          {fields.map(({ key, name, ...restField }) => (
            <div key={key} className="medical-history-item">
              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    {...restField}
                    name={[name, 'condition']}
                    label={t('intake.medicalHistory.medicalConditions.fields.condition')}
                    rules={[
                      { required: true, message: t('intake.medicalHistory.medicalConditions.validation.conditionRequired') },
                      { max: 200, message: t('intake.medicalHistory.medicalConditions.validation.conditionMaxLength') }
                    ]}
                  >
                    <Input placeholder={t('intake.medicalHistory.medicalConditions.placeholders.condition')} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'diagnosedDate']}
                    label={t('intake.medicalHistory.medicalConditions.fields.diagnosedDate')}
                  >
                    <MomentDatePicker
                      style={{ width: '100%' }}
                      placeholder={t('intake.medicalHistory.medicalConditions.placeholders.selectDate')}
                      format="MM/DD/YYYY"
                      disabledDate={(current) => current && current > moment().endOf('day')}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={6}>
                  <Form.Item
                    {...restField}
                    name={[name, 'status']}
                    label={t('intake.medicalHistory.medicalConditions.fields.status')}
                    initialValue="Active"
                  >
                    <Select>
                      <Option value="Active">{t('intake.medicalHistory.medicalConditions.status.active')}</Option>
                      <Option value="Resolved">{t('intake.medicalHistory.medicalConditions.status.resolved')}</Option>
                      <Option value="Chronic">{t('intake.medicalHistory.medicalConditions.status.chronic')}</Option>
                      <Option value="Unknown">{t('intake.medicalHistory.medicalConditions.status.unknown')}</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 0]}>
                <Col xs={24}>
                  <Form.Item
                    {...restField}
                    name={[name, 'notes']}
                    label={t('intake.medicalHistory.medicalConditions.fields.notes')}
                  >
                    <TextArea
                      rows={2}
                      placeholder={t('intake.medicalHistory.medicalConditions.placeholders.notes')}
                      maxLength={500}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div className="remove-item-button">
                <Button
                  type="text"
                  danger
                  icon={<MinusCircleOutlined />}
                  onClick={() => remove(name)}
                >
                  {t('intake.medicalHistory.medicalConditions.buttons.remove')}
                </Button>
              </div>
            </div>
          ))}

          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {t('intake.medicalHistory.medicalConditions.buttons.add')}
            </Button>
          </Form.Item>

          {fields.length === 0 && (
            <div className="no-items-message">
              <p>{t('intake.placeholders.noMedicalConditions')}</p>
            </div>
          )}
        </>
      )}
    </Form.List>
  );
};

export default MedicalConditionsSection;
